import store from 'store2'
import {
  config
} from '@/config';

const cache = {
  session: store.session
}

cache.set = function (e, t, i = 0) {
  /*
	 *创建缓存
	 * @param e 缓存名称
	 * @param t 缓存值
	 * @param i 缓存时间 毫秒
	 */
  if (!config.cache) return
  var n = +new Date(), // 从1970/01/01 到目前的毫秒数
    a = true,
    o = {
      expire: i ? n + parseInt(i) : 0,
      value: t
    };
  try {
    store.set(e, o)
  } catch (e) {
    a = false
  }
  return a
}

cache.get = function (e) {
  /**
	 * e--cache_key
	 */
  var i = +new Date(),
    n = '';
  i = parseInt(i);
  try {
    n = store.get(e);
    n.expire > i || n.expire == 0 ? n = n.value : (n = '', cache.del(e))
  } catch (err) {
    n = null
  }
  return n
}

cache.del = function (e) {
  /*
	 *清除缓存
	 * @param e 缓存名称
	 */
  var t = true;
  try {
    store.remove(e)
  } catch (e) {
    t = false
  }
  return t
}
cache.expireIn = 1000 * 60 * 60 * 2
export {
  cache
}
